import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import searchComboComponent from "@/components/child/searchCombo/search.vue";
import { Component } from "@/decorators";
import PaginationModel from "@/models/paginationModel";
import CampanhaRecompensaResgateModel, {
    CampanhaRecompensaResgateParameters,
} from "@/models/programafidelidade/campanhaRecompensaResgateModel";
import CampanhaRecompensaResgateService from "@/services/campanhaRecompensaResgateService";
import PDFService from "@/services/pdf/PDFService";
import { convertToDateWithTimeInputString } from "@/utils/common/date";

import ListComponentBase from "../listComponentBase";

@Component({
    components: {
        dateTimePickerComponent,
        searchComboComponent,
    },
})
export default class CampanhaRecompensaResgateListComponent extends ListComponentBase<CampanhaRecompensaResgateModel> {
    private resgatePDFService = new PDFService("RecompensaPDF");

    isHidden = false;
    filtro: Array<Object> = [];
    dataFilter1: Date = null;
    dataFilter2: Date = null;
    clienteId: number = null;

    extraActions: Array<object> = [];
    gridExtraActionsImprimir: Array<GridAction> = [];

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn(
                "dataResgate",
                this.$t("__.Components.parent.crud.resgates.list_vue_html.dataResgate"),
                GridColumnType.DateTime,
            ),
            new GridColumn(
                "nomeCliente",
                this.$t("__.Components.parent.crud.resgates.list_vue_html.nomeCliente"),
                GridColumnType.String,
            ),
            new GridColumn(
                "pontosUsados",
                this.$t("__.Components.parent.crud.resgates.list_vue_html.pontuacaoUtilizada"),
                GridColumnType.Integer,
            ),
            new GridColumn(
                "recompensaResgatada",
                this.$t("__.Components.parent.crud.resgates.list_vue_html.recompensaResgatada"),
                GridColumnType.String,
            ),
        ];
    }

    private beforeMount() {
        this.setProps(new CampanhaRecompensaResgateService(), "campanhaRecompensaResgate", "campanhaRecompensaResgate");
    }

    private onExtraAction(name: string, model: CampanhaRecompensaResgateModel) {
        if (name.trim() == "imprimir-resgate") {
            this.onImprimirResgate(model);
        }
    }

    public async onImprimirResgate(model: CampanhaRecompensaResgateModel) {
        await this.resgatePDFService.geraPDF(model.id);
    }

    private onAdvancedFilter() {
        this.isHidden = !this.isHidden;
        this.load();
    }

    public async afterLoad() {
        this.extraActions.splice(0);
        this.gridExtraActionsImprimir.splice(0);

        for (let i = 0; i < this.gridData.length; i++) {
            this.gridExtraActionsImprimir.push(
                new GridAction("imprimir-resgate", "Imprimir Resgate.", "fa fa-print", GridColors.DARKGRAY),
            );
        }

        this.extraActions.push(this.gridExtraActionsImprimir);
    }

    public async loadMethod() {
        const customParameters: CampanhaRecompensaResgateParameters = {
            dataInicial: convertToDateWithTimeInputString(this.dataFilter1 ?? this.filtro[0]),
            dataFinal: convertToDateWithTimeInputString(this.dataFilter2 ?? this.filtro[1]),
            clienteId: this.clienteId,
        };

        return await this.service
            .list(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pageIndex,
                this.pageSize,
                customParameters,
            )
            .withLoading()
            .resolveWithJSON<PaginationModel<CampanhaRecompensaResgateModel>>();
    }
}
